// Copyright TraderEvolution Global LTD. © 2017-2026. All rights reserved.
import { Color } from '../../../Graphics';
import { PriceType } from '@shared/utils/History/CashItemUtils';
import { IndicatorScriptBase } from '../IndicatorScriptBase';
import { LineStyle } from '../IndicatorScriptBaseEnums';
import { InputParameterInteger } from '../InputParamaterClasses/InputParameterInteger';
import { InputParameterCombobox } from '../InputParamaterClasses/InputParameterCombobox';
export class SMMA extends IndicatorScriptBase {
    constructor() {
        super();
        // #region Initialization
        this.ProjectName = 'Smoothed Moving Average';
        this.Comments = 'Smoothed Moving Average';
        // #endregion
        this.SetIndicatorLine('SMMA', Color.Red, 1, LineStyle.SimpleChart);
        this.SeparateWindow = false;
        this.MAPeriod = 2;
        super.InputParameter(new InputParameterInteger('MAPeriod', 'Period of Smoothed Moving Average:', 0, 1, 99999, 0, 1));
        this.sourcePrices = PriceType.Close;
        super.InputParameter(new InputParameterCombobox('sourcePrices', 'Sources prices for MA', 0, [
            { Close: PriceType.Close },
            { Open: PriceType.Open },
            { High: PriceType.High },
            { Low: PriceType.Low },
            { Typical: PriceType.Typical },
            { Medium: PriceType.Medium },
            { Weighted: PriceType.Weighted }
        ]));
    }
    Init() {
        this.IndicatorShortName(this.GetIndicatorShortName());
    }
    GetIndicatorShortName() {
        return 'SMMA(' + this.MAPeriod + ')';
    }
    getCustomName() {
        return 'SMMA (' + this.ProjectName + ')';
    }
    OnQuote() {
        super.OnQuote();
        const count = this.CurrentData.Count;
        if (count <= this.MAPeriod) {
            return;
        }
        if (count === this.MAPeriod + 1) {
            let sum = 0;
            for (let i = 0; i < this.MAPeriod; i++) {
                sum += this.CurrentData.getPriceByType(this.sourcePrices, i);
            }
            this.SetValue(0, 0, sum / this.MAPeriod);
        }
        else {
            const prevMa = this.GetValue(0, 1);
            this.SetValue(0, 0, (prevMa * (this.MAPeriod - 1) + this.CurrentData.getPriceByType(this.sourcePrices, 0)) / this.MAPeriod);
        }
    }
}
